import { graphql, httpClient, resolveApiUrl } from '#shared/api'
import UnapprovedServicePlansResponse from '../model/unapproved-service-plans-response'

export default async function getUnapprovedServicePlans(after: string | undefined = undefined, count = 20) {
  const response = await httpClient.post<UnapprovedServicePlansResponse>(resolveApiUrl('@sd-orders'), {
    json: graphql(
      `
        query ($count: Int!, $after: String) {
          servicePlans(first: $count, after: $after, where: { template: { isApproved: { eq: false } } }) {
            nodes {
              clientId
              createdAt
              id
              price {
                amount
                currency
              }
              template {
                id
                name
                details {
                  explanation
                }
              }
            }

            pageInfo {
              endCursor
              startCursor
              hasNextPage
              hasPreviousPage
            }
          }
        }
      `,
      { count, after }
    ),
  })

  const responseBody = await response.json()

  return responseBody.data.servicePlans
}
